import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "../use-api-context"
import { fetchFinancialAccount, fetchHouseholdFinancialAccounts } from "./api"

export function useFetchHouseholdFinancialAccounts(householdId: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["household", householdId, "financial_accounts"],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No API context found")
      const response = await fetchHouseholdFinancialAccounts(context, householdId)
      return response.financial_accounts
    },
    enabled: options?.enabled !== undefined ? options.enabled : !!householdId,
  })
}

export function useFetchFinancialAccount(householdId: string, accountId: string, options?: { enabled?: boolean }) {
  const getContext = useApiContext()

  return useQuery({
    queryKey: ["household", householdId, "financial_accounts", accountId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No API context found")
      return fetchFinancialAccount(context, householdId, accountId)
    },
    enabled: options?.enabled !== undefined ? options.enabled : !!(householdId && accountId),
  })
}
